// ── Meter Reading Data ──
export const meterReadingItems = [
  { id: 1,  unitName: 'CNG 1',                          openRead: 89767.030,    closeRead: 89767.030,    saleQty: 0.000, itemRate: 96.00,  testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 2,  unitName: 'CNG 2',                          openRead: 163039.490,   closeRead: 163039.490,   saleQty: 0.000, itemRate: 96.00,  testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 3,  unitName: 'Road Side N1 Diesel - Tank 2',   openRead: 3319589.560,  closeRead: 3319589.560,  saleQty: 0.000, itemRate: 96.52, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 4,  unitName: 'Road Side N2 Diesel - Tank 2',   openRead: 2845537.370,  closeRead: 2845537.370,  saleQty: 0.000, itemRate: 96.52, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 5,  unitName: 'Road Side N3 MS - Tank 1',       openRead: 140720.140,   closeRead: 140720.140,   saleQty: 0.000, itemRate: 108.34, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 6,  unitName: 'Road Side N4 MS - Tank 1',       openRead: 67566.420,    closeRead: 67566.420,    saleQty: 0.000, itemRate: 108.34, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 7,  unitName: 'Tank Side N1 Diesel - Tank 1',   openRead: 280225.250,   closeRead: 280225.250,   saleQty: 0.000, itemRate: 96.52, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 8,  unitName: 'Tank Side N2 Diesel - Tank 1',   openRead: 498367.330,   closeRead: 498367.330,   saleQty: 0.000, itemRate: 96.52, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 9,  unitName: 'Tank Side N3 Diesel - Tank 1',   openRead: 1036212.450,  closeRead: 1036212.450,  saleQty: 0.000, itemRate: 96.52, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 10, unitName: 'Tank Side N3 MS - Tank 1',       openRead: 1916909.460,  closeRead: 1916909.460,  saleQty: 0.000, itemRate: 108.34, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 11, unitName: 'Tank Side N4 Diesel - Tank 1',   openRead: 1062230.560,  closeRead: 1062230.560,  saleQty: 0.000, itemRate: 96.52, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
  { id: 12, unitName: 'Tank Side N4 MS - Tank 1',       openRead: 539441.350,   closeRead: 539441.350,   saleQty: 0.000, itemRate: 108.34, testing: 0.00, evapLoss: 0.00, taxPer: 0.00, tax: 0.00, amount: 0.00 },
];

export const totalItems = [
  { name: 'CNG',    quantity: 0.000, tax: 0.00, amount: 0.00 },
  { name: 'Diesel', quantity: 0.000, tax: 0.00, amount: 0.00 },
  { name: 'Petrol', quantity: 0.000, tax: 0.00, amount: 0.00 },
];

// ── Dashboard Stats ──
export const dashboardStats = {
  todaySales:     { value: '₹1,24,580', change: '+8.2%', up: true },
  totalPumps:     { value: '12', change: 'Active', up: true },
  fuelStock:      { value: '18,420 L', change: '-2.1%', up: false },
  creditPending:  { value: '₹32,100', change: '+3 parties', up: false },
};

export const salesTrend = [
  { day: 'Mon', diesel: 42000, petrol: 28000, cng: 9600 },
  { day: 'Tue', diesel: 55000, petrol: 31000, cng: 11200 },
  { day: 'Wed', diesel: 48000, petrol: 29500, cng: 10400 },
  { day: 'Thu', diesel: 61000, petrol: 35000, cng: 12800 },
  { day: 'Fri', diesel: 57000, petrol: 33000, cng: 11500 },
  { day: 'Sat', diesel: 72000, petrol: 41000, cng: 14200 },
  { day: 'Sun', diesel: 65000, petrol: 37000, cng: 13100 },
];

export const recentTransactions = [
  { id: 'TXN001', date: '04-12-2025', type: 'Meter Reading', amount: 124580, status: 'Saved' },
  { id: 'TXN002', date: '04-12-2025', type: 'Lube Sale',     amount: 8450,   status: 'Saved' },
  { id: 'TXN003', date: '04-12-2025', type: 'Credit Sale',   amount: 32100,  status: 'Pending' },
  { id: 'TXN004', date: '03-12-2025', type: 'Purchase',      amount: 210000, status: 'Received' },
  { id: 'TXN005', date: '03-12-2025', type: 'Bill Receipt',  amount: 18750,  status: 'Paid' },
];

// ── Pump Data ──
export const pumps = [
  { id: 1, pumpNo: '1', name: 'Road Side Pump 1', product: 'Diesel', nozzles: 2, status: 'Active',  lastReading: 3319589.56 },
  { id: 2, pumpNo: '2', name: 'Road Side Pump 2', product: 'MS',     nozzles: 2, status: 'Active',  lastReading: 140720.14  },
  { id: 3, pumpNo: '3', name: 'Tank Side Pump 1', product: 'Diesel', nozzles: 4, status: 'Active',  lastReading: 280225.25  },
  { id: 4, pumpNo: '4', name: 'Tank Side Pump 2', product: 'MS',     nozzles: 2, status: 'Inactive',lastReading: 539441.35  },
  { id: 5, pumpNo: '5', name: 'CNG Pump 1',       product: 'CNG',    nozzles: 2, status: 'Active',  lastReading: 89767.03   },
  { id: 6, pumpNo: '6', name: 'CNG Pump 2',       product: 'CNG',    nozzles: 2, status: 'Active',  lastReading: 163039.49  },
];

// ── Master Data ──
export const products = [
  { id: 1, code: 'MS',     name: 'Motor Spirit (Petrol)', hsnCode: '27101260', unit: 'Ltr', taxPer: 18, rate: 108.34 },
  { id: 2, code: 'HSD',    name: 'High Speed Diesel',     hsnCode: '27101940', unit: 'Ltr', taxPer: 0,  rate: 96.52  },
  { id: 3, code: 'CNG',    name: 'Compressed Natural Gas',hsnCode: '27112100', unit: 'Kg',  taxPer: 14, rate: 96.00  },
  { id: 4, code: 'LUB001', name: 'Engine Oil 10W-30',     hsnCode: '27101991', unit: 'Ltr', taxPer: 18, rate: 280.00 },
  { id: 5, code: 'LUB002', name: 'Gear Oil 90',           hsnCode: '27101991', unit: 'Ltr', taxPer: 18, rate: 195.00 },
];

export const tanks = [
  { id: 1, tankNo: 'T-01', product: 'MS',  capacity: 20000, currentStock: 12450, minLevel: 2000 },
  { id: 2, tankNo: 'T-02', product: 'HSD', capacity: 40000, currentStock: 28600, minLevel: 4000 },
  { id: 3, tankNo: 'T-03', product: 'CNG', capacity: 5000,  currentStock: 3200,  minLevel: 500  },
];

export const customers = [
  { id: 1, name: 'Ravi Transport Co.',    gstin: '36AABC1234D1Z5', credit: 50000, balance: 32100, type: 'Credit' },
  { id: 2, name: 'Lakshmi Roadways',      gstin: '36XYZC5678E2Z2', credit: 75000, balance: 12000, type: 'Credit' },
  { id: 3, name: 'Cash Customer',         gstin: '',               credit: 0,     balance: 0,     type: 'Cash'   },
  { id: 4, name: 'Sai Enterprises',       gstin: '36PQRS9012F3Z8', credit: 30000, balance: 8500,  type: 'Credit' },
];
export const suppliers = [
  { id: 1, name: 'HPCL Depot',         gstin: '36HPCL1234H1Z1', contact: '9876543210', product: 'MS, HSD' },
  { id: 2, name: 'BPCL Distributor',   gstin: '36BPCL5678B2Z3', contact: '9988776655', product: 'CNG'     },
  { id: 3, name: 'Lube Oil Traders',   gstin: '36LUBO9012L3Z6', contact: '9123456789', product: 'Lube'    },
];

// ── Sale Data ──
export const saleRecords = [
  { id: 1, date: '04-12-2025', billNo: 'SL-2410', customer: 'Cash', product: 'HSD', qty: 50,   rate: 96.52,  amount: 4826.00, status: 'Paid'    },
  { id: 2, date: '04-12-2025', billNo: 'SL-2411', customer: 'Ravi Transport',  product: 'HSD', qty: 200,  rate: 96.52,  amount: 19304.00, status: 'Credit'  },
  { id: 3, date: '04-12-2025', billNo: 'SL-2412', customer: 'Cash', product: 'MS',  qty: 30,   rate: 108.34, amount: 3250.20, status: 'Paid'    },
  { id: 4, date: '04-12-2025', billNo: 'SL-2413', customer: 'Sai Enterprises', product: 'HSD', qty: 500,  rate: 96.52,  amount: 48260.00, status: 'Credit'  },
  { id: 5, date: '03-12-2025', billNo: 'SL-2409', customer: 'Cash', product: 'CNG', qty: 10,   rate: 96.00,  amount: 960.00,  status: 'Paid'    },
];

// ── Lube Sales ──
export const lubeSales = [
  { id: 1, date: '04-12-2025', billNo: 'LB-0321', customer: 'Cash', product: 'Engine Oil 10W-30', qty: 4,  rate: 280.00, taxPer: 18, tax: 201.60,  amount: 1321.60 },
  { id: 2, date: '04-12-2025', billNo: 'LB-0322', customer: 'Ravi Transport',  product: 'Gear Oil 90',      qty: 6,  rate: 195.00, taxPer: 18, tax: 210.60,  amount: 1380.60 },
  { id: 3, date: '03-12-2025', billNo: 'LB-0320', customer: 'Cash', product: 'Engine Oil 10W-30', qty: 2,  rate: 280.00, taxPer: 18, tax: 100.80,  amount: 660.80  },
];

// ── Credit Sales ──
export const creditSales = [
  { id: 1, date: '04-12-2025', party: 'Ravi Transport Co.',  product: 'HSD', qty: 200, rate: 96.52, amount: 19304.00, paid: 0,      balance: 19304.00 },
  { id: 2, date: '04-12-2025', party: 'Sai Enterprises',     product: 'HSD', qty: 500, rate: 96.52, amount: 48260.00, paid: 10000,  balance: 38260.00 },
  { id: 3, date: '03-12-2025', party: 'Lakshmi Roadways',    product: 'MS',  qty: 100, rate: 108.34, amount: 10834.00, paid: 5000,  balance: 5834.00  },
];

// ── Daily Receipt ──
export const dailyReceipts = [
  { id: 1, date: '04-12-2025', receiptNo: 'DR-0456', mode: 'Cash',   description: 'Cash Sales',        amount: 72480.00 },
  { id: 2, date: '04-12-2025', receiptNo: 'DR-0457', mode: 'UPI',    description: 'UPI Collections',   amount: 32100.00 },
  { id: 3, date: '04-12-2025', receiptNo: 'DR-0458', mode: 'NEFT',   description: 'Ravi Transport Pymt',amount: 19304.00 },
  { id: 4, date: '03-12-2025', receiptNo: 'DR-0455', mode: 'Cash',   description: 'Cash Sales',        amount: 65200.00 },
];

// ── Item Loss ──
export const itemLossRecords = [
  { id: 1, date: '04-12-2025', product: 'HSD',    lossType: 'Evaporation', qty: 2.5,  rate: 96.52,  amount: 241.30  },
  { id: 2, date: '04-12-2025', product: 'MS',     lossType: 'Testing',     qty: 1.0,  rate: 108.34, amount: 108.34  },
  { id: 3, date: '03-12-2025', product: 'CNG',    lossType: 'Leakage',     qty: 0.5,  rate: 96.00,  amount: 48.00   },
  { id: 4, date: '03-12-2025', product: 'HSD',    lossType: 'Evaporation', qty: 3.0,  rate: 96.52,  amount: 289.56  },
];

// ── Bill Receipt ──
export const billReceipts = [
  { id: 1, date: '04-12-2025', receiptNo: 'BR-0112', party: 'Ravi Transport Co.', billNo: 'SL-2411', billAmt: 19304.00, received: 19304.00, mode: 'NEFT' },
  { id: 2, date: '04-12-2025', receiptNo: 'BR-0113', party: 'Sai Enterprises',    billNo: 'SL-2413', billAmt: 48260.00, received: 10000.00, mode: 'Cash' },
  { id: 3, date: '03-12-2025', receiptNo: 'BR-0111', party: 'Lakshmi Roadways',   billNo: 'SL-2405', billAmt: 10834.00, received: 5000.00,  mode: 'UPI'  },
];

// ── Purchase ──
export const purchaseRecords = [
  { id: 1, date: '04-12-2025', billNo: 'PO-0842', supplier: 'HPCL Depot',       product: 'HSD',  qty: 10000, rate: 89.50,  amount: 895000.00, status: 'Received'  },
  { id: 2, date: '03-12-2025', billNo: 'PO-0841', supplier: 'BPCL Distributor', product: 'CNG',  qty: 2000,  rate: 82.00,  amount: 164000.00, status: 'Received'  },
  { id: 3, date: '02-12-2025', billNo: 'PO-0840', supplier: 'HPCL Depot',       product: 'MS',   qty: 8000,  rate: 96.20,  amount: 769600.00, status: 'Pending'   },
  { id: 4, date: '02-12-2025', billNo: 'PO-0839', supplier: 'Lube Oil Traders', product: 'Lube', qty: 100,   rate: 250.00, amount: 25000.00,  status: 'Received'  },
];

// ── Dip Readings ──
export const dipReadings = [
  { id: 1, date: '04-12-2025', tank: 'T-01 (MS)',  openingDip: 85, closingDip: 72, openingQty: 12450, closingQty: 10560, soldQty: 1890 },
  { id: 2, date: '04-12-2025', tank: 'T-02 (HSD)', openingDip: 92, closingDip: 78, openingQty: 28600, closingQty: 24250, soldQty: 4350 },
  { id: 3, date: '04-12-2025', tank: 'T-03 (CNG)', openingDip: 64, closingDip: 60, openingQty: 3200,  closingQty: 3000,  soldQty: 200  },
  { id: 4, date: '03-12-2025', tank: 'T-01 (MS)',  openingDip: 96, closingDip: 85, openingQty: 14040, closingQty: 12450, soldQty: 1590 },
];
// ── Payment Data ──
export const paymentRecords = [
  { id: 1, date: '04-12-2025', voucherNo: 'PV-0442', party: 'HPCL Depot',       amount: 150000, mode: 'NEFT',   status: 'Paid' },
  { id: 2, date: '04-12-2025', voucherNo: 'PV-0443', party: 'Lube Oil Traders', amount: 25000,  mode: 'Cash',   status: 'Paid' },
  { id: 3, date: '03-12-2025', voucherNo: 'PV-0441', party: 'BPCL Distributor', amount: 82000,  mode: 'UPI',    status: 'Paid' },
  { id: 4, date: '02-12-2025', voucherNo: 'PV-0440', party: 'Misc Expenses',    amount: 1200,   mode: 'Cash',   status: 'Paid' },
];
